module.exports = __webpack_public_path__ + "img/vampireCharm.adc3f3fe.jpeg";